import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Modal from "../Modal";
import ModalFooter from "../ModalFooter";
import Button from "../Button";
import RumSnippet from "../RumSnippet";
export const EVENT_UPDATE_NOTE = "update-note";
export default function ModalRumSnippet(props) {
    const { isOpen = false, onClose } = props;
    return (_jsxs(Modal, { isOpen: isOpen, onClose: onClose, id: "add-rum-modal", title: "Add RUM JavaScript Snippet", width: "medium", children: [_jsx(RumSnippet, {}), _jsxs(ModalFooter, { children: [_jsx(Button, { onClick: onClose, children: "Done" }), _jsx(Button, { variation: "tertiary-inline", onClick: onClose, children: "Cancel" })] })] }));
}
